var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectedClient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 11.6301C14.4902 11.6301 16.5202 9.60009 16.5202 7.11009C16.5202 4.62009 14.4902 2.59009 12.0002 2.59009C9.51022 2.59009 7.48022 4.62009 7.48022 7.11009C7.48022 9.60009 9.51022 11.6301 12.0002 11.6301Z",
    fill: "#B32651"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.7001 12.72H11.3001C6.78011 12.72 3.11011 16.39 3.11011 20.91C3.11011 21.19 3.33011 21.41 3.61011 21.41H20.3901C20.6701 21.41 20.8901 21.19 20.8901 20.91C20.8901 16.39 17.2201 12.72 12.7001 12.72V12.72Z",
    fill: "#B32651"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedClient);
export default __webpack_public_path__ + "static/media/selectedClient.b205189a.svg";
export { ForwardRef as ReactComponent };